// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishList/Selected.less
// module id = 931
// module chunks = 0